import { render, staticRenderFns } from "./ReportsTest.vue?vue&type=template&id=4583048c&scoped=true"
import script from "./ReportsTest.vue?vue&type=script&lang=js"
export * from "./ReportsTest.vue?vue&type=script&lang=js"
import style0 from "./ReportsTest.vue?vue&type=style&index=0&id=4583048c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4583048c",
  null
  
)

export default component.exports